import { environment } from '../../../environments/environment';

export type PublicFormDisplayMode = 'fullPage' | 'modal' | 'inline';

export function resolvePublicFormsBaseUrl(): string {
  const configured = environment.publicFormsBaseUrl?.trim();
  if (configured) {
    return configured.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return '';
}

export function buildPublicFormUrl(
  slug: string,
  options?: { mode?: PublicFormDisplayMode; baseUrl?: string }
): string {
  const base = (options?.baseUrl ?? resolvePublicFormsBaseUrl()).replace(/\/$/, '');
  const url = new URL(`${base}/public/forms/${encodeURIComponent(slug)}`);
  const mode = options?.mode ?? 'fullPage';
  if (mode !== 'fullPage') {
    url.searchParams.set('mode', mode);
  }
  return url.toString();
}

export function buildPublicFormResumeUrl(token: string, options?: { baseUrl?: string }): string {
  const base = (options?.baseUrl ?? resolvePublicFormsBaseUrl()).replace(/\/$/, '');
  return `${base}/public/forms/resume/${encodeURIComponent(token)}`;
}

export function parsePublicFormDisplayMode(value: string | null | undefined): PublicFormDisplayMode {
  if (value === 'modal' || value === 'inline') {
    return value;
  }
  return 'fullPage';
}
